export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Open guide center",
    fabLabel: "Guides",
    assistantAria: "Guide assistant",
    dontShowAgain: "Don't show again",
    centerAria: "Guide center",
    eyebrow: "GUIDE CENTER",
    title: "Learn WACheckin",
    watchedOf: "{watched} of {total} watched",
    close: "Close",
    searchPlaceholder: "Search a guide…",
    forThisScreen: "For this screen",
    watched: "Watched",
    watchGuide: "Watch guide",
    comingSoon: "Coming soon: new improvements and updates.",
    noResults: "No results for “{query}”.",
    needHelp: "Need help? ",
    contactWhatsApp: "Message us on WhatsApp",
    lightboxMeta: "{section} · Guide {n} of {total}",
    videoTitle: "Guide video",
    playerAria: "Guide player",
    prev: "Previous",
    watchOnYouTube: "Watch on YouTube",
    next: "Next",
    sections: {
      inicio: "Getting started",
      alojamiento: "Your property",
      tarifas: "Rates and channels",
      calendario: "Calendar and bookings",
      huesped: "Guest experience",
      autoridades: "Authorities",
      novedades: "What's new",
    },
    videos: {
      navigate: "Access and navigate the settings",
      propertyData: "Your property's details, location and branding",
      checkinWelcome: "Check-in, welcome message and policies",
      basePrices: "Base prices and channel-derived rates",
      calendar: "Calendar: bookings, availability and prices",
      guestJourney: "The guest journey: messages, codes and automations",
      guestVerification: "Guest verification and review requests",
      authorities: "Connect authorities and send traveler reports",
    },
    ai: {
      cta: "See the video list",
      assistant: "Assistant",
      inicio: "First day here? Let me show you the basics in 2 minutes.",
      alojamiento: "Setting up your property? See how to get it just right.",
      tarifas: "Questions about pricing? Let me explain rates by channel.",
      calendario: "Want to master the calendar? Bookings, prices and availability.",
      huesped: "Shall we automate the guest journey? I'll show you step by step.",
      autoridades: "Let's connect the authorities? Send traveler reports in 1 video.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "System news",
    latestUpdates: "Latest updates",
    close: "Close",
    tabNews: "What's new",
    reports: "Reports",
    loading: "Loading…",
    emptyNews: "No news yet. You'll see improvements here as soon as we publish them.",
    showMore: "Show more",
    showLess: "Show less",
    reportProblem: "Report a problem",
    emptyReports: "You haven't sent any reports yet.",
    sendReport: "+ Send a report",
    sendNewReport: "+ Send a new report",
    capturesCount: "{count} screenshot | {count} screenshots",
    viewConversation: "View conversation →",
    new: "New",
    openedOn: "opened on {date}",
    conversationWithSupport: "Conversation with the support team",
    you: "You",
    support: "Support",
    noReplyYet: "No one from the team has replied yet. We'll let you know here as soon as they do.",
    replyPlaceholder: "Write your reply…",
    send: "Send",
    replyHint: "<b>Enter</b> sends · <b>Shift + Enter</b> new line",
    back: "Back",
    sendReportTitle: "Send a report",
    formSubtitle: "Tell us what happened and we'll look into it. You'll see the reply in your reports.",
    about: "About",
    whatHappens: "What's happening?",
    titlePlaceholder: "Sum it up in one sentence",
    describeDetail: "Describe it in detail",
    descPlaceholder: "What you expected, what happened and how to reproduce it.",
    capture: "Screenshot",
    optional: "optional",
    attachHint: "Tap to attach an image",
    sending: "Sending…",
    submitReport: "Send report",
    prev: "Previous",
    next: "Next",
    today: "Today",
    yesterday: "Yesterday",
    status: {
      open: "Open",
      in_progress: "In progress",
      resolved: "Resolved",
      closed: "Closed",
    },
    errRequired: "Tell us what's happening.",
    errSend: "Couldn't send. Please try again.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Identity Verification",
    subtitle: "To complete your check-in, we need to verify your identity",
    idDocument: "Identity Document",
    idDocumentDesc: "Take a clear photo of the front of your document (DNI, NIE, ID card, passport or license)",
    selfie: "Selfie",
    selfieDesc: "Take a selfie where your face is clearly visible",
    requirements: "Requirements:",
    req1: "Good lighting",
    req2: "Whole document within the frame",
    req3: "Legible text",
    req4: "Selfie with no accessories covering your face",
    start: "Start Verification",
    frontTitle: "Front of the document",
    alignDocument: "Line up your document within the frame",
    hintLegible: "Make sure all the details are legible",
    faceTitle: "Face Verification",
    alignFace: "Line up your face within the circle",
    hintLookCamera: "Look straight at the camera with no accessories",
    reviewTitle: "Review your photos",
    reviewSubtitle: "Check that all the images are clear and legible",
    frontDocTitle: "Front of document",
    retake: "Retake",
    back: "Back",
    submit: "Send for verification",
    processingTitle: "Verifying your identity",
    processingDesc: "We're validating your documents. This may take a few seconds...",
    dontClose: "Don't close this window",
    successTitle: "Verification successful!",
    successDesc: "Your identity has been verified successfully.",
    continue: "Continue",
    errorTitle: "Verification error",
    couldNotVerify: "We couldn't verify your identity. Please try again.",
    retry: "Retry",
    cameraErrorTitle: "Couldn't access the camera",
    cameraErrorDesc: "We couldn't access your camera. Please check the permissions and try again.",
    suggestions: "Suggestions:",
    tip1: "Make sure you've granted camera permissions",
    tip2: "Check that no other app is using the camera",
    tip3: "Restart your browser if the problem persists",
    tryAgainCamera: "Try again",
    couldNotVerifyShort: "We couldn't verify your identity",
    serverError: "Server error",
    tryLater: "Please try again later",
  },
};
